import React from 'react'
import type { MarketplaceBid } from '../../../services/backendService'
import '../styles/BidTable.css'

interface BidTableProps {
  bids: MarketplaceBid[]
  acceptingBidId?: string | null
  onAcceptBid: (bidId: string) => void
}

export const BidTable: React.FC<BidTableProps> = ({ bids, acceptingBidId, onAcceptBid }) => {
  const sortedBids = [...bids].sort((a, b) => a.bidAmount - b.bidAmount)
  const getAvailabilityText = (bid: MarketplaceBid) => {
    if (!bid.expiresAt) {
      return 'Not specified'
    }

    const remainingMs = new Date(bid.expiresAt).getTime() - Date.now()
    const remainingDays = Math.max(0, Math.ceil(remainingMs / (1000 * 60 * 60 * 24)))
    return remainingDays === 0 ? 'Expires today' : `${remainingDays} day${remainingDays === 1 ? '' : 's'} left`
  }

  return (
    <div className="bid-table-container">
      <table className="bid-table">
        <thead>
          <tr>
            <th>Farm Name</th>
            <th>Bid Amount</th>
            <th>Est. Days</th>
            <th>Rating</th>
            <th>Status</th>
            <th>Bid Availability</th>
            <th>Notes</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {sortedBids.map(bid => (
            <tr key={bid.id} className="bid-row">
              <td className="farm-name">
                <div>
                  <strong>{bid.farmName}</strong>
                  <span className="reviews">({bid.farmReviewCount} reviews)</span>
                </div>
              </td>
              <td className="bid-amount">
                <span className="price">${bid.bidAmount.toFixed(2)}</span>
              </td>
              <td className="est-days">{bid.estimatedDays} days</td>
              <td className="rating">
                <span className="stars">⭐ {bid.farmRating.toFixed(1)}</span>
              </td>
              <td className="bid-status">{bid.status.replace('_', ' ')}</td>
              <td className="bid-availability">{getAvailabilityText(bid)}</td>
              <td className="notes">{bid.notes}</td>
              <td className="action">
                {bid.status === 'pending' ? (
                  <button
                    className="btn-select"
                    disabled={acceptingBidId !== null}
                    onClick={() => onAcceptBid(bid.id)}
                  >
                    {acceptingBidId === bid.id ? 'Accepting...' : 'Accept'}
                  </button>
                ) : (
                  <span className="action-text">{bid.status === 'accepted' ? 'Selected' : 'Closed'}</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

